<div
  class="matrix_layoutMain container matrix_layoutUseMatrix"
  v-bind:class="getClassNameContainer"
>
  <div class="row">
    <div class="col-md-9 matrix_layoutMatrixContainerColMain">
      <div class="matrix_layoutHeader">
        <appProductPartsNamesContainer
        ></appProductPartsNamesContainer>
      </div>
      <div class="matrix_productPartsMainContainer matrix_table">
        <appProductParts></appProductParts>
        <appBackToMatrixButton></appBackToMatrixButton>
        <appUploadTable></appUploadTable>
        <appPersonalizationButton
          class="matrix_personzalizeButtonMain"
          v-show="getMatrixComplete && getPersonalizationFullPage"
        ></appPersonalizationButton>
      </div>
      <div class="matrix_summaryInformation">
        <appSummaryTable></appSummaryTable>
        <appInformationTable></appInformationTable>
      </div>
      <div class="matrix_summaryInformation">
        <appFactsheet></appFactsheet>
      </div>
    </div>
    <div class="col-md-3 matrix_layoutMatrixContainerColSidebar">
      <appCostCenter></appCostCenter>
      <appQuantityTable>
        <appQuantityContainer></appQuantityContainer>
        <appInputQuantity></appInputQuantity>
      </appQuantityTable>
      <appAddToCartButton
        class="matrix_addToCartButtonMain"
        v-if="getAddToCartFullPage"
      ></appAddToCartButton>
      <appSummarySelectedPageOptions></appSummarySelectedPageOptions>
      <appOtherOptionsTable>
        <appOtherOptionsContainer></appOtherOptionsContainer>
      </appOtherOptionsTable>
      <appOptionsTable>
        <appOptionsContainer></appOptionsContainer>
        <appInputCustomFormatInsert></appInputCustomFormatInsert>
      </appOptionsTable>
      <appUploadTable alwaysShow="true"></appUploadTable>
      <appPersonalizationButton
        class="matrix_personzalizeButtonMobile"
        v-show="getPersonalizationFullPage"
      ></appPersonalizationButton>
      <appAddToCartButton
        class="matrix_addToCartButtonMobile"
        v-if="getAddToCartFullPage"
      ></appAddToCartButton>
      <appQuotationButton></appQuotationButton>
    </div>
  </div>
</div>
